module.exports = __webpack_public_path__ + "static/media/bw.6f58d6dd.svg";